import { render, staticRenderFns } from "./Bottombar.vue?vue&type=template&id=0a319638&scoped=true"
var script = {}
import style0 from "./Bottombar.vue?vue&type=style&index=0&id=0a319638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a319638",
  null
  
)

export default component.exports